import { FormControl, FormHelperText, MenuItem } from '@material-ui/core';
import { observer } from 'mobx-react';
import React from 'react';

import { GetActiveContractsResponseDto } from '../../../core/api/dtos';
import { injectTSDI } from '../../../core/common/tsdi';
import { I18n } from '../../../core/i18n';
import { StyledSelect } from '../../../core/styles';
import { SharedContractDissolutionStore } from '../../shared-contract-dissolution-store';
import { StyledBlackInputLabel, StyledBlackLabel } from '../../styles';
import { ContractTerminationStore } from '../contract-termination-store';

export interface DateSelectProps {
    contract: GetActiveContractsResponseDto;
}

export const DateSelect = observer((props: DateSelectProps) => {
    const { formatDate, translate } = injectTSDI(I18n);
    const { getCancelContractForm } = injectTSDI(ContractTerminationStore);
    const { updateDateIfValid } = injectTSDI(SharedContractDissolutionStore);
    const cancelContractForm = getCancelContractForm(props.contract.contractId);
    if (!cancelContractForm) {
        return <></>;
    }
    const { cancellationDate } = cancelContractForm.wrappedField;

    return (
        <FormControl
            fullWidth
            required
            variant="outlined"
            error={Boolean(cancellationDate.error)}
        >
            <StyledBlackInputLabel
                id="terminate-contract-by"
                htmlFor="terminate-contract-by-input"
            >
                {translate('public.content.terminate.contract.by')}
            </StyledBlackInputLabel>
            <StyledSelect
                labelId="terminate-contract-by"
                inputProps={{ id: 'terminate-contract-by-input' }}
                id="contract-termination-date"
                value={cancellationDate.value?.toDate().valueOf() ?? ''}
                label={
                    <StyledBlackLabel>
                        {translate('public.content.terminate.contract.by')}
                    </StyledBlackLabel>
                }
                onChange={(event) => updateDateIfValid(event, cancellationDate)}
            >
                {props.contract.cancellationDates?.map((date) => (
                    <MenuItem
                        key={date.valueOf().toString()}
                        value={date.valueOf().toString()}
                    >
                        {formatDate(date)}
                    </MenuItem>
                ))}
            </StyledSelect>
            <FormHelperText>
                {cancellationDate.error
                    ? translate(cancellationDate.error)
                    : undefined}
            </FormHelperText>
        </FormControl>
    );
});
